module.exports = __webpack_public_path__ + "img/bg4.eac843a5.png";